import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradeMapDepartmentDetails from "./routes/GradeMapDepartmentDetails";

export default store => ({
  path: "department",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-map-department" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [GradeMapDepartmentDetails(store)],
});
